module.exports = __webpack_public_path__ + "img/solarIcon.d9d6b3ba.svg";